import { gql } from '@apollo/client'

export const GET_CAMPAIGN_LOCATION_FILE_PUBLIC = gql`
  query campaignLocationsFilePublic($campaignUuid: String!) {
    campaignLocationsFilePublic(campaignUuid: $campaignUuid) {
      url
    }
  }
`
